import { Component, computed, Input, OnDestroy, OnInit, Signal } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { Subject, takeUntil, tap } from 'rxjs';
import { LanguageCode } from 'interfaces/enums';
import { select, Store } from '@ngxs/store';
import { UserState } from '../../../auth/state/user.state';
import { SetUserLanguage } from '../../../auth/state/user.action';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router, UrlSegment } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    protected selectedLangSignal: Signal<LanguageCode> = select(UserState.userLanguage);
    protected selectedLangText: Signal<string> = computed(() => this.getLanguageText(this.selectedLangSignal()));
    @Input() wasScrolled: boolean;
    protected isSidebarOpen = false;
    protected langCode = LanguageCode;
    private destroy$ = new Subject<void>();
    public logoInteractive = false;

    constructor(
        private store: Store,
        private themeService: ThemeService,
        private translationService: TranslateService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.setTheme('dark');
        this.updateLogoInteractivity();
    }

    public changeLang(language: LanguageCode): void {
        this.store.dispatch(new SetUserLanguage({ language }));
    }

    protected getLanguageText(langCode: LanguageCode): string {
        switch (langCode) {
            case this.langCode.EN:
                return this.translationService.instant('general.language.english');
            case this.langCode.DE:
                return this.translationService.instant('general.language.german');
            default:
                return 'Unknown';
        }
    }

    private setTheme(mode: 'dark' | 'light') {
        this.themeService.setTheme(mode);
        localStorage.setItem('theme', JSON.stringify(mode));
    }

    private updateLogoInteractivity(): void {
        this.router.events
            .pipe(
                takeUntil(this.destroy$),
                tap(event => {
                    if (event instanceof NavigationEnd) {
                        const currentRoute = event.urlAfterRedirects;
                        this.logoInteractive = currentRoute !== '/';
                    }
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
